// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2TqD2","header":"PatientBlock_header__2jLGC","label":"PatientBlock_label__vrOSa","option":"PatientBlock_option__1QVQr"};